<template>
    <div>
        <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
            <div class="text-center p-2">
                <h4 class="text-primary pb-3">{{ $t('deactivate-progress.form.title') }}</h4>
                <div class="pb-5">
                    <p>{{ $t('deactivate-progress.form.text1') }}</p>
                    <p class="mx-auto w-75">{{ $t('deactivate-progress.form.text2') }}</p>
                    <p>{{ $t('deactivate-progress.form.text3') }}</p>
                </div>
                <h4 class="pb-3">{{ $t('deactivate-progress.form.NotesForCancellation') }}</h4>
                <div class="how-to p-4 text-left text-justify">
                    <form class="form-inline" action="">
                        <h5 class="mb-4">{{ $t('deactivate-progress.form.point1') }}</h5>
                        <div class="form-check ml-4 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox1" v-model="formData.checkBox1" v-on:change="changeCheckbox(formData.checkBox1)">
                            <label class="form-check-label pl-2" for="checkbox1">{{ $t('deactivate-progress.form.description1-1') }}</label>
                        </div>
                        <p class="ml-4 pl-4 mb-4"><small>{{ $t('deactivate-progress.form.warn1') }}</small></p>
                        <h5 class="mb-4">{{ $t('deactivate-progress.form.point2') }}</h5>
                        <div class="form-check ml-4 mb-3 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox2" v-model="formData.checkBox2" v-on:change="changeCheckbox(formData.checkBox2)">
                            <label class="form-check-label pl-2" for="checkbox2">{{ $t('deactivate-progress.form.description2-1') }}</label>
                        </div>
                        <div class="form-check ml-4 mb-3 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox3" v-model="formData.checkBox3" v-on:change="changeCheckbox(formData.checkBox3)">
                            <label class="form-check-label pl-2" for="checkbox3">{{ $t('deactivate-progress.form.description2-2') }}</label>
                        </div>
                        <div class="form-check ml-4 mb-3 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox4" v-model="formData.checkBox4" v-on:change="changeCheckbox(formData.checkBox4)">
                            <label class="form-check-label pl-2" for="checkbox4">{{ $t('deactivate-progress.form.description2-3') }}</label>
                        </div>

                        <h5 class="mb-4">{{ $t('deactivate-progress.form.point3') }}</h5>
                        <div class="form-check ml-4 mb-3 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox5" v-model="formData.checkBox5" v-on:change="changeCheckbox(formData.checkBox5)">
                            <label class="form-check-label pl-2" for="checkbox5">{{ $t('deactivate-progress.form.description3-1') }}</label>
                        </div>
                        <div class="form-check ml-4 mb-3 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox6" v-model="formData.checkBox6" v-on:change="changeCheckbox(formData.checkBox6)">
                            <label class="form-check-label pl-2" for="checkbox6">{{ $t('deactivate-progress.form.description3-2') }}</label>
                        </div>
                        <div class="form-check ml-4 mb-3 w-100 justify-content-start">
                            <input class="form-check-input" type="checkbox" id="checkbox7" v-model="formData.checkBox7" v-on:change="changeCheckbox(formData.checkBox7)">
                            <label class="form-check-label pl-2" for="checkbox7">{{ $t('deactivate-progress.form.description3-3') }}</label>
                        </div>
                    </form>

                </div>
                <div class="text-center">
                    <h6>{{ $t('deactivate-progress.form.confirm1') }}<br>
                    {{ $t('deactivate-progress.form.confirm2') }}<br>
                    {{ $t('deactivate-progress.form.confirm3') }}<router-link to="/terms" target="_blank" class="text-primary">{{ $t('deactivate-progress.form.terms') }}</router-link>{{ $t('deactivate-progress.form.confirm4') }}</h6>
                </div>
                <div class="text-danger mt-2" v-if="errors.balance_hec">
                    <h6>{{ $t('deactivate-progress.form.error1-1') }}<br>
                    {{ $t('deactivate-progress.form.error1-2') }}
                    </h6>
                </div>
                <div class="text-danger mt-2" v-if="errors.incomplete_remittance">
                    <h6>{{ $t('deactivate-progress.form.error2-1') }}<br>
                    {{ $t('deactivate-progress.form.error2-2') }}
                    </h6>
                </div>
                <div class="text-danger mt-2" v-if="errors.aube_wallet || errors.hec_wallet">
                    <h6>{{ $t('deactivate.form.error3-1-wallet-exists') }}<br>
                    {{ $t('deactivate.form.error3-2-wallet-exists') }}
                    </h6>
                </div>
                <div class="text-danger mt-2" v-if="errors.forthing_contract">
                    <h6>{{ $t('deactivate.form.error4-1-has-forthing-contract') }}<br>
                    {{ $t('deactivate.form.error4-2-has-forthing-contract') }}
                    </h6>
                </div>
                <div class="text-center mt-3">
                    <button type="submit" class="btn btn-primary" @click="handleOnSubmit" :disabled="!isAllChecked">{{ $t('deactivate-progress.form.cancelMembership') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import usersService from "../../../services/UserService";
import AuthUtil     from '../../../utils/AuthUtil';

export default {
    data() {
        return {
            formData: {
                checkBox1: false,
                checkBox2: false,
                checkBox3: false,
                checkBox4: false,
                checkBox5: false,
                checkBox6: false,
                checkBox7: false,
            },
            errors: this.getDefaultFields(),
        }
    },

    methods: {
        changeCheckbox(checkBox) {
            checkBox = !checkBox;
        },

        getDefaultFields() {
            return {
                balance_hec: '',
                incomplete_remittance: '',
                hec_wallet: '',
                aube_wallet: '',
                forthing_contract: '',
            };
        },

        async handleOnSubmit() {
            this.errors = this.getDefaultFields();
            try {
                const isDeactivated = await usersService.deactivate();
                if (isDeactivated) {
                    AuthUtil.clearAuth();
                    this.$router.push('deactivate-progress/complete');
                }
            }
            catch (err) {
                if (err.response.data.errors) {
                    err.response.data.errors.forEach(errItem => {
                        if (errItem.field) {
                            this.errors[errItem.field] = errItem.message[0];
                        }
                    })
                }
            }
        },
    },

    computed: {
        isAllChecked() {
            return  this.formData.checkBox1 &&
                    this.formData.checkBox2 &&
                    this.formData.checkBox3 &&
                    this.formData.checkBox4 &&
                    this.formData.checkBox5 &&
                    this.formData.checkBox6 &&
                    this.formData.checkBox7;
        }
    }
}
</script>

<style scoped>
h5 {
    width: 550px;
}

button {
    white-space: nowrap;
}

small {
    font-size: xx-small;
    letter-spacing: -1px;
}

.how-to {
    white-space: pre-wrap;
    background-color: rgb(215, 211, 229);
    margin-bottom: 20px;
    padding: 10px;
}

.account-recovery {
    background-color: white;
}
</style>
